import { useState, useEffect, useCallback } from "react";
import { Api } from "../request/api/api";
import { CreateEquipmentDto, EquipmentDict, UpdateEquipmentDto } from "../model/Dto/Dict/Equipment";

export function useEquipmentDict(categoryId: string) {
    const [equipment, setEquipment] = useState<EquipmentDict[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchEquipment = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const catId = categoryId !== "" ? categoryId : undefined;
            const result = await Api.dict.getAllEquipmentDict(catId);
            setEquipment(result);
        } catch {
            setError("Ошибка загрузки экипировки");
        } finally {
            setLoading(false);
        }
    }, [categoryId]);

    const createEquipment = useCallback(async (data: CreateEquipmentDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createEquipment(data);
            if (result) {
                await fetchEquipment();
                return true;
            }
            setError("Ошибка создания экипировки");
            return false;
        } catch {
            setError("Ошибка создания экипировки");
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchEquipment]);

    const updateEquipment = useCallback(async (id: string, data: UpdateEquipmentDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateEquipment(id, data);
            if (result) {
                await fetchEquipment();
                return true;
            }
            setError("Ошибка обновления экипировки");
            return false;
        } catch {
            setError("Ошибка обновления экипировки");
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchEquipment]);

    const deleteEquipment = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteEquipment(id);
            if (result) {
                await fetchEquipment();
                return true;
            }
            setError("Ошибка удаления экипировки");
            return false;
        } catch {
            setError("Ошибка удаления экипировки");
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchEquipment]);

    useEffect(() => {
        fetchEquipment();
    }, [fetchEquipment]);

    return { equipment, loading, error, createEquipment, updateEquipment, deleteEquipment };
}
